<template>
  <div>
    <div class="header">
      <h4>Sensemore</h4>
      <Navuser />
    </div>
    <el-row class="layout">
      <div class="landing">
        <el-menu router :default-active="activeLink" class="el-menu-vertical">
          <el-menu-item index="/partnerUser">
            <i class="el-icon-user"></i>
            <span>Users</span>
          </el-menu-item>
          <el-menu-item index="/customer">
            <i class="el-icon-s-custom"></i>
            <span>Customers</span>
          </el-menu-item>
          <el-menu-item index="/gateway">
            <i class="el-icon-custom"
              ><IconBase :iconColor="'#909399'"> <IconSenseway /> </IconBase
            ></i>
            <span>Senseway</span>
          </el-menu-item>
          <el-menu-item index="/trigger">
            <i class="el-icon-custom"
              ><IconBase :iconColor="'#909399'"> <IconSenseway /> </IconBase
            ></i>
            <span>Trigger</span>
          </el-menu-item>
          <el-menu-item index="/device">
            <i class="el-icon-custom"
              ><IconBase :iconColor="'#909399'"> <IconSensemore /> </IconBase
            ></i>
            <span>Devices</span>
          </el-menu-item>
          <el-menu-item index="/shipping">
            <i class="el-icon-ship"></i>
            <span>Shipping</span>
          </el-menu-item>
          <el-menu-item index="/preference">
            <i class="el-icon-setting"></i>
            <span>Preferences</span>
          </el-menu-item>
        </el-menu>
        <router-view />
      </div>
    </el-row>
  </div>
</template>

<script>
import IconBase from "./icons/IconBase";
import IconSensemore from "./icons/IconSensemore";
import IconSenseway from "./icons/IconSenseway";
import { mapState } from "vuex";

import Navuser from "./NavUser";

export default {
  name: "Layout",
  components: { Navuser, IconBase, IconSenseway, IconSensemore },
  data() {
    return {
      isColapsed: true,
      activeLink: null,
    };
  },
  computed: {
    ...mapState("account", ["partnerUser"]),
  },
  mounted: function () {
    this.activeLink = this.$route.path;
  },
  methods: {
    route(path) {
      console.lg(path);
      this.$router.push({ path: path });
    },
  },
  watch: {
    $route(to) {
      this.activeLink = to.path;
    },
  },
};
</script>
<style scoped>
.layout {
  display: flex;
  flex-direction: row;
}
.landing {
  padding-right: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.el-menu-vertical {
  min-height: calc(100vh - 60px);
}
.header {
  display: flex;
  color: white;
  align-items: center;
  flex-direction: row;
  background: #343a40;
  padding-left: 30px;
  padding-right: 15px;
  height: 40px;
}
</style>